module.exports = __webpack_public_path__ + "img/incident_icon.09f06d85.png";